const isSelectable = shape => !(shape.get('isLocked') ||
    shape.get('isGroupLocked') ||
    shape.get('isBackground') ||
    shape.get('isHidden'));

export default isSelectable;
